import { createContext } from 'react';

export interface IDialogContextState {
  handleCloseDialog?: () => void;
}

export const DialogContextState = createContext<IDialogContextState>({});
